import React, { useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { FormGroup, Label, Col, Button, Row } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../Components/Register.css";
import Header from '../Components/Header';
import { set } from 'firebase/database';
import { Spinner } from 'react-bootstrap';
import { BASE_URL } from '../config';

function CreateDoctorSchedule() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [doctor, setDoctor] = useState({
        startTime: '',
        endTime: '',
        dayofweek: '',
    });

    const [errors, setErrors] = useState({
        startTime: '',
        endTime: '',
        dayofweek: '',
    });

    const [scheduleData, setScheduleData] = useState([]); // State to store API response
    const [conflictingTimes, setConflictingTimes] = useState([]); // Store full conflicting time ranges
    const [showDutyTime, setShowDutyTime] = useState(true);
    const [loading, setLoading] = useState(false);

    const daysOfWeek = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
    ];

    const minutesOptions = ['00', '20', '40']; // Custom minute options
    const hoursOptions = Array.from({ length: 24 }, (_, index) => index.toString().padStart(2, '0')); // 24-hour format hours

    // Fetch schedule data when the selected day of the week changes
    const checkScheduleAvailability = async (day) => {
        setLoading(true);
        const userId = id; // Assuming UserId is stored in sessionStorage

        if (!userId) {
            console.error("User not found in session.");
            return;
        }

        try {
            const response = await fetch(`${BASE_URL}SpecialistDoctorCheckSchedule?Userid=${userId}&Day=${day}`);

            if (!response.ok) {
                setLoading(false);
                throw new Error("Failed to fetch schedule availability.");
            }

            setLoading(false);
            const data = await response.json();
            console.log('Schedule availability data:', data);
            setScheduleData(data.getSpecialistScheduleCheck || []); // Save the response data in state
            setShowDutyTime(false);
            // Find all conflicting times
            const conflictingTimeRanges = [];

            data.getSpecialistScheduleCheck.forEach((schedule) => {
                const { startTime, endTime } = schedule;
                conflictingTimeRanges.push({ startTime, endTime });
            });

            setConflictingTimes(conflictingTimeRanges);

        } catch (error) {
            setLoading(false);
            console.error("Error fetching schedule availability:", error);
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setDoctor((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        // Clear the error for the specific field
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));

        // If the day of the week changes, check the schedule
        if (name === 'dayofweek' && value !== '') {
            checkScheduleAvailability(value); // Call the API when the day is selected
        }
    };

    // Function to check if the selected time range is conflicted with any existing schedule
    const isTimeRangeConflicted = (start, end) => {
        return conflictingTimes.some((conflict) => {
            const conflictStart = conflict.startTime;
            const conflictEnd = conflict.endTime;

            // Check if the selected time range overlaps with any conflicting time range
            return (start >= conflictStart && start < conflictEnd) ||
                (end > conflictStart && end <= conflictEnd) ||
                (start <= conflictStart && end >= conflictEnd); // Full overlap case
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const { startTime, endTime, dayofweek } = doctor;

        let validationErrors = {};

        // Validation: Check if any field is empty and set error messages
        if (!startTime) validationErrors.startTime = 'Start time is required';
        if (!endTime) validationErrors.endTime = 'End time is required';
        if (!dayofweek) validationErrors.dayofweek = 'Day of the week is required';

        // If there are validation errors, set the error state and stop submission
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const requestPayload = {
            DoctorId: id,
            StartTime: startTime,
            EndTime: endTime,
            DayOfWeek: dayofweek
        };

        try {
            const response = await fetch(`${BASE_URL}Specialist_DoctorAvailability`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestPayload),
            });

            if (!response.ok) {
                const errorResponse = await response.json();
                throw new Error(errorResponse.Message);
            }

            const data = await response.json();
            console.log('Schedule Create successful:', data);

            // On success, navigate and reset form
            navigate(`/DoctorSchedule/${id}`);

            setDoctor({
                startTime: '',
                endTime: '',
                dayofweek: '',
            });
            setErrors({});
        } catch (error) {
            console.error('Failed to Create Schedule:', error);
        }
    };

    const formatTo12Hour = (time24) => {
        const [hour, minute] = time24.split(':').map(Number);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 || 12; // convert '0' to '12'
        return `${hour12}:${minute.toString().padStart(2, '0')} ${ampm}`;
    };

    const timeToMinutes = (time) => {
        const [hours, minutes] = time.split(":").map(Number);
        return hours * 60 + minutes;
    };


    return (
        <div className="container-fluid">
            <Header />
            <div className="row justify-content-center align-items-center py-5">
                <div className="col-12 col-md-8 col-lg-6">
                    <div className="card shadow-lg" style={{ borderRadius: '15px' }}>

                        <div className="card-header text-center bg_primary text-white">
                            <h5 className="fw-bold">Create Doctor Schedule</h5>
                        </div>

                        <div className="card-body">
                            <FormGroup row className="mb-4">
                                <Col sm="3" md="4" lg="3">
                                    <Label className="fw-bold">Select Day <span className="text-danger">*</span></Label>
                                </Col>
                                <Col sm="9" md="8" lg="9">
                                    <select
                                        className={`form-select ${errors.dayofweek ? 'is-invalid' : ''}`}
                                        name="dayofweek"
                                        value={doctor.dayofweek}
                                        onChange={handleInputChange}
                                    >
                                        <option value="" selected hidden>Select Day</option>
                                        {daysOfWeek.map((day, index) => (
                                            <option key={index} value={day === 'Select Day' ? '' : day}>
                                                {day}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.dayofweek && <div className="invalid-feedback">{errors.dayofweek}</div>}
                                </Col>
                            </FormGroup>

                            {
                                loading ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                        <Spinner size="lg" />
                                    </div>
                                ) : (<>
                                    {
                                        scheduleData.length > 0 ? (
                                            <>
                                                <p className='text-danger text-center'>You already have an appointment on this day.</p>
                                            </>
                                        ) : (

                                            !showDutyTime && (
                                                <FormGroup row className="mb-4">
                                                    <Col sm="3" md="4" lg="3">
                                                        <Label className="fw-bold">Duty Time <span className="text-danger">*</span></Label>
                                                    </Col>

                                                    <Col sm="9" md="8" lg="9">
                                                        <Row>
                                                            <Col sm="12" md="6" lg="6">
                                                                <span><b>From</b></span>
                                                                {/* Start Time Input */}
                                                                <select
                                                                    className={`form-select ${errors.startTime ? 'is-invalid' : ''}`}
                                                                    name="startTime"
                                                                    value={doctor.startTime || ''}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                >
                                                                    {hoursOptions.map((hour) =>
                                                                        minutesOptions.map((minute) => {
                                                                            const time = `${hour}:${minute}`;
                                                                            const isConflicted = isTimeRangeConflicted(time, doctor.endTime);
                                                                            const isAlreadySelected = scheduleData.some(schedule => schedule.startTime === time); // Check if already selected
                                                                            const isDisabled = isConflicted || isAlreadySelected; // Disable if conflicted or already selected

                                                                            return (
                                                                                <option
                                                                                    key={`${hour}-${minute}`}
                                                                                    value={time}
                                                                                    className={isConflicted || isAlreadySelected ? 'text-danger' : ''}
                                                                                    disabled={isDisabled} // Disable conflicting or already selected times
                                                                                >
                                                                                    {time}
                                                                                </option>
                                                                            );
                                                                        })
                                                                    )}
                                                                </select>
                                                                {errors.startTime && <div className="invalid-feedback">{errors.startTime}</div>}
                                                            </Col>

                                                            <Col sm="12" md="6" lg="6">
                                                                <span><b>To</b></span>
                                                                {/* End Time Input */}
                                                                <select
                                                                    className={`form-select ${errors.endTime ? 'is-invalid' : ''}`}
                                                                    name="endTime"
                                                                    value={doctor.endTime || ''}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                >
                                                                    {hoursOptions.map((hour) =>
                                                                        minutesOptions.map((minute) => {
                                                                            const time = `${hour}:${minute}`;
                                                                            const startMinutes = timeToMinutes(doctor.startTime);
                                                                            const endMinutes = timeToMinutes(time);

                                                                            const isAfterStart = doctor.startTime && endMinutes > startMinutes;
                                                                            const isConflicted = isTimeRangeConflicted(doctor.startTime, time);
                                                                            const isAlreadySelected = scheduleData.some(schedule => schedule.endTime === time);
                                                                            const isDisabled = !isAfterStart || isConflicted || isAlreadySelected;

                                                                            return (
                                                                                <option
                                                                                    key={`${hour}-${minute}`}
                                                                                    value={time}
                                                                                    className={isDisabled ? 'text-danger' : ''}
                                                                                    disabled={isDisabled}
                                                                                >
                                                                                    {time}
                                                                                </option>
                                                                            );
                                                                        })
                                                                    )}
                                                                </select>
                                                                {errors.endTime && <div className="invalid-feedback">{errors.endTime}</div>}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </FormGroup>
                                            )

                                        )
                                    }
                                    {scheduleData.length > 0 && (
                                        <div className="mb-4">
                                            <h6>Current Schedule</h6>
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Start Time</th>
                                                        <th>End Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {scheduleData.map((schedule, index) => (
                                                        // <tr key={index}>
                                                        //     <td>{schedule.startTime}</td>
                                                        //     <td>{schedule.endTime}</td>
                                                        // </tr>
                                                        <tr key={index}>
                                                            <td>{formatTo12Hour(schedule.startTime)}</td>
                                                            <td>{formatTo12Hour(schedule.endTime)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </>)
                            }


                            {/* Displaying the schedule data in a table */}

                        </div>

                        <div className="card-footer text-center">
                            <Button color="primary" disabled={loading || showDutyTime || scheduleData.length > 0} className="btn_primary" size="lg" block onClick={handleSubmit}>
                                Add Schedule
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateDoctorSchedule;
